/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AnnotationSettingsKey, AnnotationSettingsState } from "./annotation-settings-reducer";

export const selectAnnotationSettingsState = createFeatureSelector<AnnotationSettingsState>(AnnotationSettingsKey);

export const selectAnnotationSettings = createSelector( selectAnnotationSettingsState, (state) => state.annotationSettings);

export const selectRevitInformation = createSelector( selectAnnotationSettingsState, (state) => state.revitInformation);

export const selectTagLocationPath = createSelector( selectAnnotationSettingsState, (state) => state.tagLocationPath);

export const selectFittingsTagLocationPath = createSelector( selectAnnotationSettingsState, (state) => state.fittingsTagLocationPath);

export const selectCurrentSelectionResult = createSelector( selectAnnotationSettingsState, (state) => state.currentSelectionResult);